import { Controller } from "@hotwired/stimulus"

// Toggles between "Upload" and "URL" for card type Apple image fields (logo, icon, strip).
export default class extends Controller {
  static targets = ["uploadRow", "urlRow", "uploadTab", "urlTab"]

  connect() {
    this.showUpload()
  }

  showUpload() {
    this.uploadRowTarget?.classList.remove("d-none")
    this.urlRowTarget?.classList.add("d-none")
    this.uploadTabTarget?.classList.add("active")
    this.urlTabTarget?.classList.remove("active")
  }

  showUrl() {
    this.uploadRowTarget?.classList.add("d-none")
    this.urlRowTarget?.classList.remove("d-none")
    this.uploadTabTarget?.classList.remove("active")
    this.urlTabTarget?.classList.add("active")
  }
}
